<template>
  <div data-component="NotActiveTabOverlay" class="h-100">
    <b-row class="text-center h-100">
      <b-col cols="12" md="auto" style="width:80%" class="mx-auto my-auto">
        <b-icon-exclamation-triangle class="warning-icon mb-4" />
        <p class="warning-not-active-tab">
          Warning! You have another active tab opened on this application.
        </p>
        <p class="warning-not-active-tab">Only one tab is supported.</p>
        <br />
        <p class="warning-not-active-tab">
          You can either close this tab and use the active one (recommended), or
          click the button below to make it active.
        </p>
        <b-button
          class="mt-3"
          ref="make-active-tab"
          variant="danger"
          size="lg"
          aria-describedby="make-active-tab"
          @click="makeCurrentTabActive"
          >Make it active tab</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BIconExclamationTriangle } from "bootstrap-vue";

export default {
  components: {
    BIconExclamationTriangle,
  },
  methods: {
    makeCurrentTabActive() {
      this.$store.dispatch("header/makeCurrentTabActive").then(
        // force page refresh as the server state might have changed
        // note, we could implement the age thing to see if this is
        // required
        () => this.$router.go(0)
      );
    },
  },
};
</script>

<style scoped>
.warning-not-active-tab {
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
}
.warning-icon {
  color: white;
  font-size: 10rem;
  font-weight: bold;
}
</style>